import FeesAlert from './feesAlert'

export default FeesAlert
